/** User-facing labels for agentic run step tool names (never show raw internal ids in the UI). */
export const AGENTIC_STEP_LABELS = {
    // Chart tools — Java ToolCatalog camelCase (AgentLoop). Snake_case kept for Charts-loop
    // SSE until that executor is deleted.
    getChartTopology: 'Getting chart topology',
    get_chart_topology: 'Getting chart topology',
    get_chart_context: 'Getting chart context',
    getChartEntities: 'Getting chart entities',
    get_chart_entities: 'Getting chart entities',
    kbEntitySearch: 'Searching entities',
    kb_entity_search: 'Searching entities',
    kbEntityDossier: 'Fetching entity details',
    kb_entity_dossier: 'Fetching entity details',
    kbGraphNeighbors: 'Exploring nearby entities',
    kb_graph_neighbors: 'Exploring nearby entities',
    kbGraphPaths: 'Finding entity connections',
    kb_graph_paths: 'Finding entity connections',
    kbOrgMembersQuery: 'Looking up organization members',
    kb_org_members_query: 'Looking up organization members',
    resolveEntitiesForChart: 'Resolving entities for chart',
    resolve_entities_for_chart: 'Resolving entities for chart',
    getLinkedProductText: 'Loading linked report text',
    get_linked_product_text: 'Loading linked report text',
    planChartMutations: 'Planning chart updates',
    plan_chart_mutations: 'Planning chart updates',

    // Corpus tools — Java AgentLoop camelCase, plus snake_case aliases from older streams
    dslQuery: 'Searching report content',
    dsl_query: 'Searching report content',
    getDocumentContent: 'Fetching document content',
    get_document_content: 'Fetching document content',
    vectorSearch: 'Searching semantically',
    vector_search: 'Searching semantically',
    llmAnalyze: 'Analyzing document',
    llm_analyze: 'Analyzing document',
    getReports: 'Finding reports',
    get_reports: 'Finding reports',
    getUsers: 'Looking up users',
    get_users: 'Looking up users',
    getMapData: 'Getting map data',
    get_map_data: 'Getting map data',
    server_info: 'Checking connection',
};

/**
 * @param {string | null | undefined} toolName
 * @returns {string}
 */
export function getAgenticStepLabel(toolName) {
    if (!toolName) {
        return 'Running step';
    }

    const mapped = AGENTIC_STEP_LABELS[toolName];
    if (mapped) {
        return mapped;
    }

    const words = toolName
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .toLowerCase();

    return `Running ${words}`;
}
